import { useEffect } from "react";
import Navbar from "@/components/portfolio/Navbar";
import Hero from "@/components/portfolio/Hero";
import Marquee from "@/components/portfolio/Marquee";
import Projects from "@/components/portfolio/Projects";
import Experience from "@/components/portfolio/Experience";
import Journal from "@/components/portfolio/Journal";
import Contact from "@/components/portfolio/Contact";

export default function Portfolio() {
  useEffect(() => {
    document.title = "Ali Renan Uyanık — Robotics & EE Engineer";
  }, []);

  return (
    <main data-testid="portfolio-root" className="relative bg-black text-white min-h-screen">
      <Navbar />
      <Hero />
      <Marquee />
      <Projects />
      <Experience />
      <Journal />
      <Contact />
    </main>
  );
}
